import { shouldPartnerSign } from '../hasPartner';

const COMPLETED_SIGNATURE_TYPES = ['manuellement', 'électroniquement'];
const PENDING_SIGNATURE_TYPE = 'universign';

export const hasValidSignature = (signatureInfo) => (
    !!signatureInfo
    && !!signatureInfo.date
    && COMPLETED_SIGNATURE_TYPES.includes(signatureInfo.type)
);

export const hasPendingSignature = (signatureInfo) => (
    !!signatureInfo
    && !!signatureInfo.date
    && PENDING_SIGNATURE_TYPE === signatureInfo.type
);

export const isRipSigned = (rip) => {
    const signatures = rip.clientAndPartnerSignatureDate || {};
    const clientSigned = hasValidSignature(signatures.client);

    if (!clientSigned) {
        return false;
    }

    if (!shouldPartnerSign(rip)) {
        return true;
    }

    return hasValidSignature(signatures.partner);
};

export const isRipPendingSignature = (rip) => {
    if (isRipSigned(rip)) {
        return false;
    }

    const signatures = rip.clientAndPartnerSignatureDate || {};
    const clientPending = hasPendingSignature(signatures.client);

    if (!shouldPartnerSign(rip)) {
        return clientPending;
    }

    return clientPending || hasPendingSignature(signatures.partner);
};

export const isRipSignedManually = (rip) => {
    if (!isRipSigned(rip)) {
        return false;
    }

    const signatures = rip.clientAndPartnerSignatureDate || {};
    const clientType = signatures.client && signatures.client.type;
    const partnerType = signatures.partner && signatures.partner.type;

    if (!shouldPartnerSign(rip)) {
        return 'manuellement' === clientType;
    }

    return 'manuellement' === clientType && 'manuellement' === partnerType;
};

export const isRipSignedElectronically = (rip) => {
    if (!isRipSigned(rip)) {
        return false;
    }

    return !isRipSignedManually(rip);
};
